import { useEffect, useState } from "react";

export const Typewriter = ({ words, className = "" }) => {
  const [text, setText] = useState("");
  const [wordIndex, setWordIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const word = words[wordIndex % words.length];
    let speed = deleting ? 35 : 75;
    if (!deleting && text === word) speed = 1800;
    const t = setTimeout(() => {
      if (!deleting && text === word) {
        setDeleting(true);
      } else if (deleting && text === "") {
        setDeleting(false);
        setWordIndex((i) => (i + 1) % words.length);
      } else {
        setText(word.slice(0, text.length + (deleting ? -1 : 1)));
      }
    }, speed);
    return () => clearTimeout(t);
  }, [text, deleting, wordIndex, words]);

  return (
    <span className={className} data-testid="typewriter-text">
      {text}
      <span className="inline-block w-[3px] h-[0.85em] bg-brand ml-1 align-middle animate-pulse" />
    </span>
  );
};
